import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const ChatFooter = styled.div<{ $collapsed: boolean }>`
  position: absolute;
  right: ${({ $collapsed }) => ($collapsed ? '1.75rem' : '1rem')};
  bottom: ${({ $collapsed }) => ($collapsed ? '4.75rem' : '3.75rem')};
  left: ${({ $collapsed }) => ($collapsed ? '1.75rem' : '1rem')};
  z-index: 2;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 960px) {
    display: none;
  }
`;

export const ChatFooterLink = styled(NavLink)`
  position: relative;
  display: flex;
  width: 100%;
  min-height: 2.625rem;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  padding: 0.5rem 0.75rem;
  border: 0.0625rem solid var(--chat-footer-border);
  border-radius: 1.3125rem;
  color: ${({ theme }) => theme.colors.textSecondary};
  background: color-mix(in srgb, var(--foreground) 10%, transparent);
  font-size: 0.875rem;
  text-transform: uppercase;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;

  &:hover,
  &.active {
    background: ${({ theme }) => theme.colors.navbarHoverItem};
  }

  &:focus-visible {
    outline: 0.1875rem solid var(--primary-action);
    outline-offset: 0.125rem;
  }
`;

export const ChatFooterIcon = styled.span`
  display: inline-flex;
  width: 2rem;
  height: 1.625rem;
  flex: 0 0 2rem;
  align-items: center;
  justify-content: center;
  color: currentColor;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
